import React from 'react';

class Success extends React.Component {

    reset = () => {
        window.location.reload();
    };

    render() {
        return (
            <div className="other">
                <img src={require("../images/success.svg")} alt="Success!" />
                <h2>Thanks {this.props.name.split(" ")[0]}!</h2>
                <p>Your recommendation and ratings have been successfully submitted.</p>
                <button className="reset" onClick={this.reset}>Start Again</button>
            </div>
        )
    }
}

export default Success;